import { Method, send } from '../../lib/MyHttp';

/**
 * 리스트
 */
export const GetList = (component, params, success, fail) => {
    let paramsT = { ...params };
    if (!params['role']) delete paramsT['role'];
    if (!params['name']) delete paramsT['name'];

    send(component, Method.GET, '/a/adminUser', paramsT, success, fail);
};

/**
 * 엑셀 다운로드
 */
export const GetListDownload = (component, params, success, fail) => {
    let paramsT = { ...params };
    if (!params['role']) delete paramsT['role'];
    if (!params['name']) delete paramsT['name'];

    send(component, Method.GET, '/a/adminUser/download', paramsT, success, fail);
};

/**
 * 정보
 */
export const Get = (component, id, success, fail) => {
    const params = {};
    send(component, Method.GET, '/a/adminUser/' + id, params, success, fail);
};

/**
 * 등록
 */
export const Create = (component, params, success, fail) => {
    const paramsT = {
        title: params.title,
        email: params.email,
        name: params.name,
        password: params.password,
        role: params.role,
        phone: params.phone,
        tel: params.tel,
        account: params.account,
        price: params.price,
        status: params.status,
    };

    send(component, Method.POST, '/a/adminUser/', paramsT, success, fail);
};

/**
 * 업데이트
 */
export const Update = (component, id, params, success, fail) => {
    const paramsT = {
        title: params.title,
        email: params.email,
        name: params.name,
        password: params.password,
        role: params.role,
        phone: params.phone,
        tel: params.tel,
        account: params.account,
        price: params.price,
        status: params.status,
    };

    if (params['password'] === '') delete paramsT['password'];

    send(component, Method.PUT, '/a/adminUser/' + id, paramsT, success, fail);
};

/**
 * 삭제
 */
export const Delete = (component, id, success, fail) => {
    const params = {};
    send(component, Method.DELETE, '/a/adminUser/' + id, params, success, fail);
};

/**
 * 비밀번호 초기화
 */
export const ResetPassword = (component, id, success, fail) => {
    const params = {};
    send(component, Method.PUT, '/a/adminUser/' + id + '/resetPassword', params, success, fail);
};
